// Client-side utilities - safe to import anywhere
import { QRISC_QUERY_PARAM } from './constants'

/**
 * Appends the QRISC (which stands for, Quiz Results Innovative Swing Completed) query parameter to a given URL.
 *
 * Used to indicate that a user has completed the Quiz Results Innovative Swing experiment flow, which allows SSR to
 * determine which checkout page variant to show.
 *
 * @param href - The base URL to append the query parameter to
 * @returns The URL with the 'qrisc' query parameter appended
 */
export const appendQRISCQueryParam = (href: string): string => {
  if (!href) return href

  const separator = href.includes('?') ? '&' : '?'
  return `${href}${separator}${QRISC_QUERY_PARAM}`
}
